import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

/* Add local and extensions to dayjs */
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.locale('fr');

/**
 * Get Time from now (Il y a 12 heures)
 * If you pass withoutSuffix true, you can get the value without the suffix (12 heures).
 */
export const getTimeFromNow = (date: string, withoutSuffix?: boolean) =>
  dayjs(date).fromNow(withoutSuffix).replace('il', 'Il');

/**
 * Get a fresh Day.js object with the current date and time
 */
export const getNow = () => dayjs();

/**
 * Get formatted date
 * @param date - The date
 * @param format - The format string
 */
export const getFormattedDate = (date: string, format: string) =>
  dayjs(date).format(format);
